import { render, staticRenderFns } from "./SearchGoodList.vue?vue&type=template&id=0f4a8247&scoped=true"
import script from "./SearchGoodList.vue?vue&type=script&lang=ts"
export * from "./SearchGoodList.vue?vue&type=script&lang=ts"
import style0 from "./SearchGoodList.vue?vue&type=style&index=0&id=0f4a8247&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4a8247",
  null
  
)

export default component.exports